import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { PersonalInformationService } from './personal-information.service';
import { ProfileModel } from '../../../models/Profile.Model';
import { Subscription } from 'rxjs/Subscription';
import { PersonalInfoService, CountryService, StateService } from '../../../_services/index';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../_services/index';

@Component({
  selector: 'app-personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.css'],
  providers: [PersonalInformationService]
})
export class PersonalInformationComponent implements OnInit, OnDestroy {
  phonemask: any[] = [ '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  ss: any[] = [ /\d/, /\d/, /\d/,'-', /\d/, /\d/,'-', /\d/, /\d/, /\d/];
  date: any[] = [ /\d/, /\d/,'-', /\d/, /\d/,'-', /\d/, /\d/, /\d/, /\d/];

  profileForm: FormGroup;
  formErrors: any;
  submitBtnText = '';
  submitting: boolean;
  getProfileSub: Subscription;
  formChangeSub: Subscription;
  submitProfileSub: Subscription;
  getCountryeSub: Subscription;
  getHomeStateSub: Subscription;
  getMailStateSub: Subscription;
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  countries: any;
  homeStates: any;
  mailStates: any;
  showHideMailAddressFlag: boolean;
  fieldErrors: any;
  currentUser: any;
  disableFields: string;
  public firstName: string;
  public middleName: string;
  public lastName: string;
  public personalEmail: string;
  public facebookUrl: string;
  public twitterUserName: string;
  public phones: number;
  public homeStreetAddress: string;
  public homeStreetAddress2: string;
  public homeCountry: string;
  public homeCity: string;
  public homeState: string;
  public homeZip: string;
  public isAddressSame: boolean;
  public mailStreetAddress: string;
  public mailStreetAddress2: string;
  public mailCountry: string;
  public mailCity: string;
  public mailState: string;
  public mailZip: string;
  public permaResiStatus: boolean;
  public loading: boolean;
  public checkChange: boolean;
  public valueChange = false;
  public canDeactivateCheck = false;
  public checkingSubmit = false;
  showDes = true;
  declinetostate= false;
  asian = false;
  pacificislander= false;
  selected = 0;
  preferences = [];
  checkboxesArray= [];
  ethnic = [];
  ethnicArray = [];
  showAlienRegistrationNumber = false;
  showVisaDate = false;
  showsexualorientationother = false;
  isCNIC = false;

  constructor(
    private _fb: FormBuilder,
    public pf: PersonalInformationService,
    public api: PersonalInfoService,
    public countryApi: CountryService,
    private router: Router,
    public stateApi: StateService,
    private loginservice: AuthenticationService,

  ) { }

  ngOnInit()  {
    this.formErrors = this.pf.formErrors;
    this.submitBtnText = 'Next';

    this.preferences = [
      {'Name': 'Email', 'isChosen': false},
      {'Name': 'Text', 'isChosen': false}
      /* {'Name':'Mail','isChosen': false} */
    ];

    for (let checkbox of this.preferences) {
      this.checkboxesArray.push(this._fb.group({
        isChosen: checkbox.isChosen,
        name: checkbox.Name,
      }));
    }

    this.ethnic = [
      {'Name': 'Hispanic or Latino', 'isChosen': false},
      {'Name': 'Not Hispanic or Latino', 'isChosen': false},
      {'Name': 'Decline to State', 'isChosen': false}
    ];

    for (let ethnicArr of this.ethnic) {
      this.ethnicArray.push(this._fb.group({
        isChosen: ethnicArr.isChosen,
        name: ethnicArr.Name,
      }));
    }

    this.createForm();
    this.getCountryList();
    this.getHomeStateList();
    this.getMailStateList();
    this.currentUser  = JSON.parse(localStorage.getItem('currentUser'));
    this.firstName    = this.currentUser ? this.currentUser.firstname : '';
    this.lastName     = this.currentUser ? this.currentUser.lastname : '';
    this.personalEmail = this.currentUser ? this.currentUser.email : '';
    this.middleName   = this.currentUser ? this.currentUser.middlename : '';
    this.showHideMailAddressFlag  = true;
    this.profileForm.get('firstName').setValue(this.firstName);
    this.profileForm.get('lastName').setValue(this.lastName);
    this.profileForm.get('personalEmail').setValue(this.personalEmail);

    this.getPersonalInfo();
    window.scrollTo(300, 500);

    this.checkCinc();
    this.onCitizenshipStatusChange('US Citizen');
  }

  createForm()  {

    let formControlArray = new FormArray(this.checkboxesArray);
    let formControlethnicArray = new FormArray(this.ethnicArray);

    this.profileForm  = this._fb.group({
      firstName: ['', [
        Validators.required,
        Validators.minLength(this.pf.textMin),
        Validators.maxLength(this.pf.titleMax),
        Validators.pattern(this.pf.noSpaces)
      ]],
      middleName: ['', [Validators.pattern(this.pf.noSpaces)]],
      lastName: ['', [
        Validators.required,
        Validators.maxLength(this.pf.titleMax),
        Validators.pattern(this.pf.noSpaces)
      ]],
      personalEmail: ['', [
        Validators.required,
        Validators.maxLength(this.pf.titleMax),
        Validators.pattern(this.pf.emailValidate)
      ]],
      personalEmails: ['', [
        Validators.maxLength(this.pf.titleMax),
        Validators.pattern(this.pf.emailValidate)
      ]],
      facebookUrl: ['', [Validators.pattern(this.pf.noSpaces)]],
      twitterUserName: ['', [Validators.pattern(this.pf.noSpaces)]],
      phones: this._fb.array([ this.createPhone() ]),
      homeStreetAddress: ['', [Validators.required]],
      homeStreetAddress2: [''],
      homeCountry: ['', [Validators.required, Validators.pattern(this.pf.noSpaces)]],
      homeCity: ['', [Validators.required]],
      homeState: ['', [Validators.required, Validators.pattern(this.pf.noSpaces)]],
      homeZip: ['', [Validators.required, Validators.pattern(this.pf.zipValidate)]],
      isAddressSame: [''],
      mailStreetAddress: ['', [Validators.required, Validators.pattern(this.pf.noSpaces)]],
      mailStreetAddress2: ['', [Validators.pattern(this.pf.noSpaces)]],
      mailCountry: ['', [Validators.required, Validators.pattern(this.pf.noSpaces)]],
      mailCity: ['', [Validators.required]],
      mailState: ['', [Validators.required, Validators.pattern(this.pf.noSpaces)]],
      mailZip: ['', [Validators.required, Validators.pattern(this.pf.zipValidate)]],
      permaResiStatus: ['', [Validators.required]],
      permanentresident_des:[],
      declinetostate:[],
      asian:[],
      indian:[],
      burmese:[],
      cambodian:[],
      chinese:[],
      filipino:[],
      hmong:[],
      indonesian:[],
      japanese:[],
      korean:[],
      laotian:[],
      singaporean:[],
      tahitian:[],
      thai:[],
      tongan:[],
      vietnamese:[],
      otherasian:[],
      black:[],
      americanindian:[],
      pacificislander:[],
      guamanian:[],
      hawaiian:[],
      samoan:[],
      otherpacificislander:[],
      white:[],
      selected:['',[Validators.required]],
      applicant: ['',[Validators.required]],
      preferences: formControlArray,
      selectedItems: new FormControl(this.mapItems(formControlArray.value), Validators.required),    
      ethnic:formControlethnicArray,
      selectedItems2: new FormControl(this.mapItems(formControlethnicArray.value), Validators.required),    
      socialsecurity:[''],
      citizenshipstatus:['US Citizen'],
      alienregistrationnumber:['',[Validators.minLength(7),Validators.maxLength(9)]],
      visaissuedate:[''],
      visaexpirationdate:[''],
      dateofbirth:[''],
      new_gender:['Male'],
      transgender:['No'],
      sexualorientation:['Straight/Heterosexual'],
      sexualorientationother:[''],
      residencyhomecommunity:['']

    });
    this.formChangeSub = this.profileForm
    .valueChanges
    .subscribe(data => this._onValueChanged());
    this._onValueChanged();

    formControlArray.valueChanges.subscribe((v) => {
      this.profileForm.controls.selectedItems.setValue(this.mapItems(v));
    });

    formControlethnicArray.valueChanges.subscribe((v) => {
      this.profileForm.controls.selectedItems2.setValue(this.mapItems(v));
    });

  }

  createPhone() {
    return this._fb.group({
      phoneNumber: ['', Validators.required],
      phoneType: ['cell', Validators.required]
    });
  }

  mapItems(items) {
    let selectedItems = items.filter(x => x.isChosen);
    return selectedItems.length ? selectedItems : null;
  }

  addPhone(): void {
    const control = <FormArray>this.profileForm.controls['phones'];
    control.push(this.createPhone());
  }
  deletePhone(i: number) {
    const control = <FormArray>this.profileForm.controls['phones'];
    control.removeAt(i);
  }

  private _onValueChanged() {

    if (this.checkChange) {
      this.valueChange = true;
    }
    if (!this.profileForm) {return; }
    const _setErrMsgs = (control: AbstractControl, errorsObj: any, field: string) => {
      if (control && control.dirty && control.invalid) {
        const messages = this.pf.validationMessages[field];
        for (const key in control.errors) {
          if (control.errors.hasOwnProperty(key)) {
            errorsObj[field] += messages[key] + '<br>';
          }
        }
      }
    };
    for (const field in this.formErrors) {
      if (this.formErrors.hasOwnProperty(field)) {
        this.formErrors[field] = '';
        _setErrMsgs(this.profileForm.get(field), this.formErrors, field);
      }
    }
  }

  onSubmit()  {
    this.loading = true;

    const race = JSON.stringify({
      declinetostate: this.profileForm.controls.declinetostate.value,
      asian: this.profileForm.controls.asian.value,
      indian: this.profileForm.controls.indian.value,
      burmese: this.profileForm.controls.burmese.value,
      cambodian: this.profileForm.controls.cambodian.value,
      chinese: this.profileForm.controls.chinese.value,
      filipino: this.profileForm.controls.filipino.value,
      hmong: this.profileForm.controls.hmong.value,
      indonesian: this.profileForm.controls.indonesian.value,
      japanese: this.profileForm.controls.japanese.value,
      korean: this.profileForm.controls.korean.value,
      laotian: this.profileForm.controls.laotian.value,
      singaporean: this.profileForm.controls.singaporean.value,
      tahitian: this.profileForm.controls.tahitian.value,
      thai: this.profileForm.controls.thai.value,
      tongan: this.profileForm.controls.tongan.value,
      vietnamese: this.profileForm.controls.vietnamese.value,
      otherasian: this.profileForm.controls.otherasian.value,
      black: this.profileForm.controls.black.value,
      americanindian: this.profileForm.controls.americanindian.value,
      pacificislander: this.profileForm.controls.pacificislander.value,
      guamanian: this.profileForm.controls.guamanian.value,
      hawaiian: this.profileForm.controls.hawaiian.value,
      samoan: this.profileForm.controls.samoan.value,
      otherpacificislander: this.profileForm.controls.otherpacificislander.value,
      white: this.profileForm.controls.white.value,
    });

    const body = JSON.stringify({
      firstName: this.profileForm.controls.firstName.value,
      middleName: this.profileForm.controls.middleName.value,
      lastName: this.profileForm.controls.lastName.value,
      personalEmail: this.profileForm.controls.personalEmail.value,
      personalEmails: this.profileForm.controls.personalEmails.value,
      facebookUrl: this.profileForm.controls.facebookUrl.value,
      twitterUserName: this.profileForm.controls.twitterUserName.value,
      phones: this.profileForm.controls.phones.value,
      homeStreetAddress: this.profileForm.controls.homeStreetAddress.value,
      homeStreetAddress2: this.profileForm.controls.homeStreetAddress2.value,
      homeCountry: this.profileForm.controls.homeCountry.value,
      homeCity: this.profileForm.controls.homeCity.value,
      homeState: this.profileForm.controls.homeState.value,
      homeZip: this.profileForm.controls.homeZip.value,
      isAddressSame: this.profileForm.controls.isAddressSame.value,
      mailStreetAddress: this.profileForm.controls.mailStreetAddress.value,
      mailStreetAddress2: this.profileForm.controls.mailStreetAddress2.value,
      mailCountry: this.profileForm.controls.mailCountry.value,
      mailCity: this.profileForm.controls.mailCity.value,
      mailState: this.profileForm.controls.mailState.value,
      mailZip: this.profileForm.controls.mailZip.value,
      permaResiStatus: this.profileForm.controls.permaResiStatus.value,
      permanentresident_des: this.profileForm.controls.permanentresident_des.value,
      race: race,
      applicant: this.profileForm.controls.applicant.value,
      preferences: JSON.stringify( this.profileForm.controls.preferences.value),
      ethnic: JSON.stringify( this.profileForm.controls.ethnic.value),
      socialsecurity:this.profileForm.controls.socialsecurity.value,
      citizenshipstatus:this.profileForm.controls.citizenshipstatus.value,
      alienregistrationnumber:this.profileForm.controls.alienregistrationnumber.value,
      visaissuedate:this.profileForm.controls.visaissuedate.value,
      visaexpirationdate:this.profileForm.controls.visaexpirationdate.value,
      dateofbirth:this.profileForm.controls.dateofbirth.value,
      new_gender:this.profileForm.controls.new_gender.value,
      transgender:this.profileForm.controls.transgender.value,
      sexualorientation:this.profileForm.controls.sexualorientation.value,
      sexualorientationother:this.profileForm.controls.sexualorientationother.value,
      residencyhomecommunity:this.profileForm.controls.residencyhomecommunity.value,
    });
    this.submitting = true;
    this.submitProfileSub = this.api.postPersonalInfo$(body)
      .subscribe(
        data => {
          this.error = false;
          this.submitting = false;
          const response = data;
          this.errorFlag = false;
          this.successMessage = response.message;
          this.loading = false;
          if (!this.canDeactivateCheck) {
            this.checkingSubmit = true;
            this.router.navigate(['/profile/academic-information']);
          }
        },
        error => {
          this.submitting = false;
          this.errorFlag = true;
          const errordata = JSON.parse(error._body);
          if (errordata.success === 0) {
            this.errorMessage = errordata.message;
            this.errorFlag = true;
            this.fieldErrors = errordata.errors;
            this.loading = false;
          }
        },
      );
  }

  private _handleSubmitSuccess(res) {
    this.error = false;
    this.submitting = false;
    const response = res;
    this.errorFlag = false;
    this.successMessage = response.message;
  }

  private _handleSubmitError(err) { }

  ngOnDestroy() {
    console.log('inside destroy');
    console.log(this.getProfileSub);
    if (this.submitProfileSub) {
      this.submitProfileSub.unsubscribe();
    }
    if (this.formChangeSub)  {
      this.formChangeSub.unsubscribe();
    }
    if (this.getProfileSub)  {
      console.log('inside submit destroy');
      this.getProfileSub.unsubscribe();
    }
    if (this.getCountryeSub)  {
      this.getCountryeSub.unsubscribe();
    }
    if (this.getHomeStateSub)  {
      this.getHomeStateSub.unsubscribe();
    }
    if (this.getMailStateSub)  {
      this.getMailStateSub.unsubscribe();
    }
  }

  getCountryList() {
    /* this.getCountryeSub = this.countryApi.countryList()
    .subscribe(res => {
      this.countries = res;
      setTimeout(() => {
        this.profileForm.patchValue({
          homeCountry: this.countries[0].id
        });
        this.getHomeStateList();
        this.profileForm.patchValue({
          mailCountry: this.countries[0].id
        });
        this.getMailStateList();
      }, 2000);
    }); */

    this.profileForm.patchValue({
      homeCountry: 'US'
    });

    this.profileForm.patchValue({
      mailCountry: 'US'
    });
  }

  getHomeStateList() {
    this.profileForm.controls['homeState'].setValue('');
    this.getHomeStateSub = this.stateApi.getStateList(this.profileForm.controls.homeCountry.value)
    .subscribe((dataResponse) => {
      this.homeStates = dataResponse;
     });
  }

  getMailStateList() {
    this.profileForm.controls['mailState'].setValue('');
    this.getMailStateSub = this.stateApi.getStateList(this.profileForm.controls.mailCountry.value)
    .subscribe((dataResponse) => {
      this.mailStates = dataResponse;
     });
  }

  showHideMailAddress() {

    if (this.profileForm.controls.isAddressSame.value === '0') {
      this.showHideMailAddressFlag = true;
      this.profileForm.controls.mailStreetAddress.setValue('');
      this.profileForm.controls.mailStreetAddress2.setValue('');
      this.profileForm.controls.mailCity.setValue('');
      this.profileForm.controls.mailZip.setValue('');
      this.profileForm.controls.mailCountry.setValue('US');
      this.getMailStateList();
      this.profileForm.controls.mailState.setValue('');
      this.profileForm.controls.mailStreetAddress.enable();
      this.profileForm.controls.mailStreetAddress2.enable();
      this.profileForm.controls.mailCity.enable();
      this.profileForm.controls.mailZip.enable();
      this.profileForm.controls.mailCountry.enable();
      this.profileForm.controls.mailState.enable();
    } else if (this.profileForm.controls.isAddressSame.value === '') {
      this.profileForm.controls.mailStreetAddress.enable();
      this.profileForm.controls.mailStreetAddress2.enable();
      this.profileForm.controls.mailCity.enable();
      this.profileForm.controls.mailZip.enable();
      this.profileForm.controls.mailCountry.enable();
      this.profileForm.controls.mailState.enable();
    }  else {
      this.profileForm.controls.mailStreetAddress.disable();
      this.profileForm.controls.mailStreetAddress2.disable();
      this.profileForm.controls.mailCity.disable();
      this.profileForm.controls.mailZip.disable();
      this.profileForm.controls.mailCountry.disable();
      this.profileForm.controls.mailState.disable();
      this.showHideMailAddressFlag = false;
      const homeStreetAddress = this.profileForm.controls.homeStreetAddress.value;
      const homeStreetAddress2 = this.profileForm.controls.homeStreetAddress2.value;
      const homeCity = this.profileForm.controls.homeCity.value;
      const homeCountry = this.profileForm.controls.homeCountry.value;
      const homeState = this.profileForm.controls.homeState.value;
      const homeZip = this.profileForm.controls.homeZip.value;
      this.profileForm.controls.mailStreetAddress.setValue(homeStreetAddress);
      this.profileForm.controls.mailStreetAddress2.setValue(homeStreetAddress2);
      this.profileForm.controls.mailCity.setValue(homeCity);
      this.profileForm.controls.mailZip.setValue(homeZip);
      this.profileForm.controls.mailCountry.setValue(homeCountry);
      this.getMailStateList();
      this.profileForm.controls.mailState.setValue(homeState);
    }
  }

  changeUpper(field) {
    let cap = '';
    if (field === 'firstName') {
      cap = this.profileForm.controls.firstName.value;
      cap = cap.charAt(0).toUpperCase() + cap.slice(1);
      this.profileForm.controls.firstName.setValue(cap);
    } else if (field === 'middleName' ) {

      cap = this.profileForm.controls.middleName.value;
      cap = cap.charAt(0).toUpperCase() + cap.slice(1);
      this.profileForm.controls.middleName.setValue(cap);

    } else if (field === 'lastName' ) {

      cap = this.profileForm.controls.lastName.value;
      cap = cap.charAt(0).toUpperCase() + cap.slice(1);
      this.profileForm.controls.lastName.setValue(cap);
    }

  }

  getPersonalInfo() {
    this.loading = true;
    const body = JSON.stringify({
          email: this.personalEmail
    });

    this.getProfileSub = this.api.getPersonalInfo(body)
    .subscribe(responsedata => {
      const personalInfodata = responsedata.data;
      if (personalInfodata.firstName) {
        this.profileForm.controls['firstName'].setValue(personalInfodata.firstName);
      }
      this.changeUpper('firstName');
      if (personalInfodata.middleName) {
        this.profileForm.controls['middleName'].setValue(personalInfodata.middleName);
      }
      this.changeUpper('middleName');
      if (personalInfodata.lastName) {
        this.profileForm.controls['lastName'].setValue(personalInfodata.lastName);
      }
      this.changeUpper('lastName');
      this.profileForm.controls['personalEmails'].setValue(personalInfodata.personalEmails);
      this.profileForm.controls['facebookUrl'].setValue(personalInfodata.facebookUrl);
      this.profileForm.controls['twitterUserName'].setValue(personalInfodata.twitterUserName);
      this.profileForm.controls['homeStreetAddress'].setValue(personalInfodata.homeStreetAddress);
      this.profileForm.controls['homeStreetAddress2'].setValue(personalInfodata.homeStreetAddress2);
      this.profileForm.controls['homeCity'].setValue(personalInfodata.homeCity);
      this.profileForm.controls['homeZip'].setValue(personalInfodata.homeZip);
      setTimeout(() => {
        if (typeof personalInfodata.homeCountry !== 'undefined') {
          this.profileForm.controls['homeCountry'].setValue(personalInfodata.homeCountry);
          this.getHomeStateList();
          this.profileForm.controls['homeState'].setValue(personalInfodata.homeState);
        }
      }, 3000);
      this.profileForm.controls['mailStreetAddress'].setValue(personalInfodata.mailStreetAddress);
      this.profileForm.controls['mailStreetAddress2'].setValue(personalInfodata.mailStreetAddress2);
      this.profileForm.controls['mailCity'].setValue(personalInfodata.mailCity);
      this.profileForm.controls['mailZip'].setValue(personalInfodata.mailZip);
      if (personalInfodata.permaResiStatus) {
        this.profileForm.controls['permaResiStatus'].setValue(personalInfodata.permaResiStatus);
        this.profileForm.controls['permanentresident_des'].setValue(personalInfodata.permanentresident_des);
        this.showHideDes();
      }
      if (personalInfodata.isAddressSame) {
        this.profileForm.controls['isAddressSame'].setValue(personalInfodata.isAddressSame);
      }
      setTimeout(() => {
        if (typeof personalInfodata.mailCountry !== 'undefined') {
          this.profileForm.controls['mailCountry'].setValue(personalInfodata.mailCountry);
          this.getMailStateList();
          this.profileForm.controls['mailState'].setValue(personalInfodata.mailState);
        }
        this.loading = false;
        this.checkChange = true;
      }, 3000);
      if (typeof personalInfodata.phones !== 'undefined') {
        const phoneLength = personalInfodata.phones.length;
        for (let i = 1; i < phoneLength; i++) {
          this.addPhone();
        }
        this.profileForm.controls['phones'].setValue(personalInfodata.phones);
      }
      let race = JSON.parse(personalInfodata.race);

      if(race){

        this.profileForm.controls.asian.setValue(race.asian);
        this.profileForm.controls.black.setValue(race.black);
        this.profileForm.controls.americanindian.setValue(race.americanindian);
        this.profileForm.controls.pacificislander.setValue(race.pacificislander);
        this.profileForm.controls.white.setValue(race.white);
        this.profileForm.controls.declinetostate.setValue(race.declinetostate);
        this.profileForm.controls.indian.setValue(race.indian);
        this.profileForm.controls.burmese.setValue(race.burmese);
        this.profileForm.controls.cambodian.setValue(race.cambodian);
        this.profileForm.controls.chinese.setValue(race.chinese);
        this.profileForm.controls.filipino.setValue(race.filipino);
        this.profileForm.controls.hmong.setValue(race.hmong);
        this.profileForm.controls.indonesian.setValue(race.indonesian);
        this.profileForm.controls.japanese.setValue(race.japanese);
        this.profileForm.controls.korean.setValue(race.korean);
        this.profileForm.controls.laotian.setValue(race.laotian);
        this.profileForm.controls.singaporean.setValue(race.singaporean);
        this.profileForm.controls.tahitian.setValue(race.tahitian);
        this.profileForm.controls.thai.setValue(race.thai);
        this.profileForm.controls.tongan.setValue(race.tongan);
        this.profileForm.controls.vietnamese.setValue(race.vietnamese);
        this.profileForm.controls.otherasian.setValue(race.otherasian);
        this.profileForm.controls.guamanian.setValue(race.guamanian);
        this.profileForm.controls.hawaiian.setValue(race.hawaiian);
        this.profileForm.controls.samoan.setValue(race.samoan);
        this.profileForm.controls.otherpacificislander.setValue(race.otherpacificislander);

      }

      this.checkdeclinetostate();
      this.checkasian();
      this.checkpacificislander();
      if (personalInfodata.isAddressSame) {
      this.profileForm.controls.mailStreetAddress.disable();
      this.profileForm.controls.mailStreetAddress2.disable();
      this.profileForm.controls.mailCity.disable();
      this.profileForm.controls.mailZip.disable();
      this.profileForm.controls.mailCountry.disable();
      this.profileForm.controls.mailState.disable();
      } else {
        this.profileForm.controls.mailStreetAddress.enable();
        this.profileForm.controls.mailStreetAddress2.enable();
        this.profileForm.controls.mailCity.enable();
        this.profileForm.controls.mailZip.enable();
        this.profileForm.controls.mailCountry.enable();
        this.profileForm.controls.mailState.enable();
      }

      if (personalInfodata.applicant) {
        this.profileForm.controls.applicant.setValue(personalInfodata.applicant);
      }

      if (personalInfodata.preferences) {
        this.profileForm.controls.preferences.setValue( JSON.parse(personalInfodata.preferences) );
      }
      if (personalInfodata.ethnic) {
        this.profileForm.controls.ethnic.setValue(JSON.parse(personalInfodata.ethnic));
      }
      

      if (personalInfodata.socialsecurity) {
        this.profileForm.controls.socialsecurity.setValue( personalInfodata.socialsecurity );
      }
      if (personalInfodata.citizenshipstatus) {
        this.profileForm.controls.citizenshipstatus.setValue( personalInfodata.citizenshipstatus );
        this.onCitizenshipStatusChange(personalInfodata.citizenshipstatus);
      }
      if (personalInfodata.alienregistrationnumber) {
        this.profileForm.controls.alienregistrationnumber.setValue( personalInfodata.alienregistrationnumber );
      }
      if (personalInfodata.visaissuedate) {
        this.profileForm.controls.visaissuedate.setValue( personalInfodata.visaissuedate );
      }
      if (personalInfodata.visaexpirationdate) {
        this.profileForm.controls.visaexpirationdate.setValue( personalInfodata.visaexpirationdate );
      }
      if (personalInfodata.dateofbirth) {
        this.profileForm.controls.dateofbirth.setValue( personalInfodata.dateofbirth );
      }
      if (personalInfodata.residencyhomecommunity) {
        this.profileForm.controls.residencyhomecommunity.setValue( personalInfodata.residencyhomecommunity );
      }
      if (personalInfodata.new_gender) {
        this.profileForm.controls.new_gender.setValue( personalInfodata.new_gender );
      }
      if (personalInfodata.transgender) {
        this.profileForm.controls.transgender.setValue( personalInfodata.transgender );
      }
      if (personalInfodata.sexualorientation) {
        this.profileForm.controls.sexualorientation.setValue( personalInfodata.sexualorientation );
        this.onSexualOrientationChange(personalInfodata.sexualorientation);
      }
      if (personalInfodata.showsexualorientationother) {
        this.profileForm.controls.showsexualorientationother.setValue( personalInfodata.showsexualorientationother );
      }

    });
  }

  showHideDes() {

    let permaResiStatus = this.profileForm.controls.permaResiStatus.value;

    if (permaResiStatus == '0') {
      this.showDes = false;
    } else {
      this.showDes = true;
    }
  }

  checkdeclinetostate() {
    if (this.profileForm.controls.declinetostate.value) {
      this.declinetostate = true;
      this.profileForm.controls.asian.setValue(false);
      this.profileForm.controls.black.setValue(false);
      this.profileForm.controls.americanindian.setValue(false);
      this.profileForm.controls.pacificislander.setValue(false);
      this.profileForm.controls.white.setValue(false);
      this.checkasian();
      this.checkpacificislander();
      this.profileForm.controls.selected.setValue(1);
    } else {
      this.declinetostate = false;
      this.profileForm.controls.selected.setValue('');
    }
  }


  checkblack() {

    this.checkselected();
  }

  checkamericanindian() {
    this.checkselected();
  }

  checkwhite() {
    this.checkselected();
  }

  checkasian() {
    if (this.profileForm.controls.asian.value) {
      this.asian = true;
      this.checkselected();
    } else{
      this.asian = false;
      this.checkselected();
      this.profileForm.controls.asian.setValue(false);
      this.profileForm.controls.indian.setValue(false);
      this.profileForm.controls.burmese.setValue(false);
      this.profileForm.controls.cambodian.setValue(false);
      this.profileForm.controls.chinese.setValue(false);
      this.profileForm.controls.filipino.setValue(false);
      this.profileForm.controls.hmong.setValue(false);
      this.profileForm.controls.indonesian.setValue(false);
      this.profileForm.controls.japanese.setValue(false);
      this.profileForm.controls.korean.setValue(false);
      this.profileForm.controls.laotian.setValue(false);
      this.profileForm.controls.singaporean.setValue(false);
      this.profileForm.controls.tahitian.setValue(false);
      this.profileForm.controls.thai.setValue(false);
      this.profileForm.controls.tongan.setValue(false);
      this.profileForm.controls.vietnamese.setValue(false);
      this.profileForm.controls.otherasian.setValue(false);

    }
  }

  checkpacificislander() {
    if (this.profileForm.controls.pacificislander.value) {
      this.pacificislander = true;
      this.checkselected();
    } else {
      this.checkselected();
      this.pacificislander = false;
      this.profileForm.controls.guamanian.setValue(false);
      this.profileForm.controls.hawaiian.setValue(false);
      this.profileForm.controls.samoan.setValue(false);
      this.profileForm.controls.otherpacificislander.setValue(false);
    }
  }

  checkselected() {

    if (this.profileForm.controls.asian.value) {
      this.profileForm.controls.selected.setValue(1);
    } else if (this.profileForm.controls.black.value) {
      this.profileForm.controls.selected.setValue(1);
    } else if (this.profileForm.controls.americanindian.value) {
      this.profileForm.controls.selected.setValue(1);
    } else if (this.profileForm.controls.pacificislander.value) {
      this.profileForm.controls.selected.setValue(1);
    } else if (this.profileForm.controls.white.value) {
      this.profileForm.controls.selected.setValue(1);
    } else if (this.profileForm.controls.declinetostate.value) {
      this.profileForm.controls.selected.setValue(1);
    } else {
      this.profileForm.controls.selected.setValue('');
    }
  }

  checkPreferences() {
    let items = this.profileForm.value;
    let length = items.preferences.filter(x => x.isChosen).length;
    items.preferences.filter(x => x.name).map(x => {});
    this.profileForm.controls['preferences'].setValue(items.preferences);
  }

  checkEthnic() {
    let items = this.profileForm.value;
    let length = items.ethnic.filter(x => x.isChosen).length;
    items.ethnic.filter(x => x.isChosen).map(x => {
      if (x.name == 'Decline to State') {
        items.ethnic.filter(xx => xx.name).map(xx => {
          if (xx.name != 'Decline to State') {
            xx.isChosen = false;
          }
        });
      }
    });

    this.profileForm.controls['ethnic'].setValue(items.ethnic);
  }

  canDeactivate() {
    if (this.valueChange  && this.checkingSubmit === false) {
      if (confirm('Want to save changes?')) {
        this.canDeactivateCheck = true;
        this.onSubmit();
      }
    }
    return true;
  }

  onCitizenshipStatusChange(value){
    //console.log(value);
    if( value == 'Permanent Resident' || value == 'Refugee/Asylee' || value == 'Temporary Resident/Amnesty'){
      this.showAlienRegistrationNumber = true;
      this.showVisaDate = false;
    }
    else if( value == 'Student Visa (F-1)' || value == 'Student Visa (M-1)' ){
      this.showAlienRegistrationNumber = false;
      this.showVisaDate = true;
    }
    else{
      this.showVisaDate = false;
      this.showAlienRegistrationNumber = false;
    }
    //this.profileForm.controls['citizenshipstatus'].setValue(value);
  }

  onSexualOrientationChange(value){
    console.log(this.profileForm);
    if( value == 'Other'){
      this.showsexualorientationother = true;
    }
    else{
      this.showsexualorientationother = false;
    }
  }

  checkCinc(){
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    //const countLength = parts.length;
    const subdomain = parts.shift();
    console.log(subdomain);
    if(subdomain == 'cinc'){
      this.isCNIC = true;
    }
    else{
      this.isCNIC = false;
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/personal-information/personal-information.component.ts